// extracted by mini-css-extract-plugin
module.exports = {"bhgdr3i":"bhgdr3i","b16w56qw":"b16w56qw"};